import { resizeGame ,DefaultQueryParams, parseQuery} from '@pascal/pascal-core';

let maxHeight = 792;
let maxWidth = 1440;
const target = document.querySelector('.root');
export const resizeGameHandler = () => {
    const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
    const isBetShop = +gameId === 156140;
    if (isBetShop) {
        maxHeight = 1080;
        maxWidth = 1920;
    }
    resizeGame(maxHeight, maxWidth, target);
};
